// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"368":"a96aa068","787":"d4cfc1d4"}[chunkId] + ".chunk.js";
};